import React from "react";
import { createRoot } from "react-dom/client";
import Video from "./dev13/example1.js";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <Video />
    </div>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(<App />);




